import React from 'react';  
import { NineCellLoading } from 'react-loadingg';
import checkTest from '../../services/checkTest';

const qs = require('querystring');

export default class Exam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };
    }

    componentDidMount() {
        const parsed = qs.parse(window.location.hash);
        let id = parsed['#/main/exam?id'] 
        let db = parsed['db']
        if (!id || !db) {
            window.location.href = "/#/main/home"
            return;
        }
        checkTest(id, db).then(res => {
            if(res.result === "ok"){
                window.location.href = "/" + db + '#/login?esame=' + id;
            } else {
                window.location.href = "/#/main/home"
            }
        })

    }

    render() {
        return(
            <NineCellLoading />
        )
    }
}